import React from 'react';
import './SubmissionConfirmation.css';

const SubmissionConfirmation = ({ onConfirm, onCancel, isLoading }) => {
  return (
    <div className="modal-overlay">
      <div className="modal-content">
        <div className="modal-header">
          <h2>Confirm Submission</h2>
        </div>
        
        <div className="modal-body">
          <div className="confirmation-icon">
            <svg width="48" height="48" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
              <path d="M9 12L11 14L15 10M21 12C21 16.9706 16.9706 21 12 21C7.02944 21 3 16.9706 3 12C3 7.02944 7.02944 3 12 3C16.9706 3 21 7.02944 21 12Z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
            </svg>
          </div>
          
          <p className="confirmation-text">
            Are you sure you want to submit your application? Once submitted, you will not be able to make any changes.
          </p>
          
          <div className="confirmation-details">
            <h4>What happens next:</h4>
            <ul>
              <li>Your application will be reviewed by our team</li>
              <li>You will receive a confirmation email</li>
            </ul>
          </div>
        </div>
        
        <div className="modal-footer">
          <button
            type="button"
            className="btn btn-secondary"
            onClick={onCancel}
            disabled={isLoading}
          >
            Cancel
          </button>
          
          <button
            type="button"
            className="btn btn-success"
            onClick={onConfirm}
            disabled={isLoading}
          >
            {isLoading ? (
              <>
                <span className="spinner"></span>
                Submitting...
              </>
            ) : (
              'Confirm & Submit'
            )}
          </button>
        </div>
      </div>
    </div>
  );
};

export default SubmissionConfirmation;
